import { Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Button } from 'ui-components';
import { DownloadIcon } from 'ui-components/dist/DownloadIcon';
import { ShareIcon } from 'ui-components/dist/ShareIcon';
import type { ContentDetailModalTrackIdType } from '~/components/ContentDetailModal';
import { CONTENT_DETAIL_MODAL_TRACK_ID } from '~/components/ContentDetailModal';
import { ExportPdfButton } from '~/components/ExportPdfButton';
import { PDF_DOCUMENT_TYPE, SOCIAL_PLATFORMS } from '~/constants';
import type { CreatorInfo } from '~/screens/ContentSharedScreen/ContentSharedScreen.types';
import type { ISearchContentResult } from '~/searchApi';
import { selectTalentManager } from '~/selectors/talent-manager';

export interface Props {
  content: ISearchContentResult;
  creator: CreatorInfo;
  onShare: (content: ISearchContentResult) => void;
  trackIds: ContentDetailModalTrackIdType;
}

export const PLATFORM_DOWNLOAD = {
  [SOCIAL_PLATFORMS.instagram]: {
    fileName: 'document.pdf',
    type: PDF_DOCUMENT_TYPE.CONTENT,
  },
  [SOCIAL_PLATFORMS.tiktok]: {
    fileName: 'document.pdf',
    type: PDF_DOCUMENT_TYPE.TIKTOK_CONTENT,
  },
  [SOCIAL_PLATFORMS.youtube]: {
    fileName: 'document.pdf',
    type: PDF_DOCUMENT_TYPE.YOUTUBE_CONTENT,
  },
} as const;

export const Actions = ({ creator, content, onShare, trackIds }: Props) => {
  const pdf = PLATFORM_DOWNLOAD[content.platform];

  const manager = useSelector(selectTalentManager);

  if (content) {
    return (
      <>
        <Flex justifyContent="flex-end" gap={2} marginY={'spacing-200'}>
          {pdf && manager && (
            <ExportPdfButton
              size="sm"
              fileName={pdf.fileName}
              leftIcon={<DownloadIcon boxSize={4} />}
              data={{ creator, content }}
              pdfType={pdf.type}
              track-id={trackIds[CONTENT_DETAIL_MODAL_TRACK_ID.downloadButton]}
            >
              Download PDF
            </ExportPdfButton>
          )}

          {onShare &&
            creator.status !== 'off-platform' &&
            Boolean(content.shareLink) && ( // hide share button if there is no share link
              <Button
                leftIcon={<ShareIcon boxSize={4} />}
                onClick={() => onShare(content)}
                size="sm"
                trackId={trackIds[CONTENT_DETAIL_MODAL_TRACK_ID.shareButton]}
              >
                Share
              </Button>
            )}
        </Flex>
      </>
    );
  }

  return null;
};
